import React from "react"
import { Plus } from "lucide-react"
import "./PracticePapersHero.style.scss"

interface PracticePapersHeroProps {
  onCreate: () => void
}

const PracticePapersHero = ({ onCreate }: PracticePapersHeroProps) => (
  <header className="practice-papers-hero">
    <div>
      <h1>Practice papers</h1>
      <p>Resume a paper or create a new one from the question bank.</p>
    </div>
    <button
      type="button"
      className="practice-papers-hero__create"
      onClick={onCreate}
    >
      <Plus size={16} />
      Create paper
    </button>
  </header>
)

export default PracticePapersHero
